export default __webpack_public_path__ + "static/media/ColorSMSBlast.f2ea2493.svg";